type RuleData = {
  countriesFrom: string;
  countriesTo: string;
  statesTo: string;
  sellersLabel: string;
  [key: string]: any;
};

export const transformData = (data: RuleData) => {
  const toArray = (value: any) => {
    if (value == null) return [];
    if (Array.isArray(value)) return value;
    return value
      .split(",")
      .map((item: string) => item.trim())
      .filter((item: string) => item.length > 0);
  };

  return {
    ...data,
    countriesFrom: toArray(data.countriesFrom),
    countriesTo: toArray(data.countriesTo),
    statesTo: toArray(data.statesTo).length > 0 ? toArray(data.statesTo) : null,
    madeInCountries: toArray(data.madeInCountries),
    sellersLabel: toArray(data.sellersLabel),
  };
};
